export const combinedInsights = {
  client_id: '',
  column_limit: '',
  dynamic_fields: '',
  fields: [
    'x4c_insights_combined.okta_reseller_key',
    'x4c_insights_combined.insight__top_product_growth_top_category',
    'x4c_insights_combined.insight__missing_product_market_basket',
    'x4c_insights_combined.insight__trending_searches_in_mdg_segment',
    'x4c_insights_combined.insight__X4C_CUST_TOP_PRODUCT_SEARCH',
    'x4c_insights_combined.insight__order_count_ytd',
    'x4c_insights_combined.insight__top_vendor_growth_with_top_product_sales',
    'x4c_insights_combined.insight__top_product_in_top_category',
    'x4c_insights_combined.insight__top_category_growth_with_top_product_sales',
    'x4c_insights_combined.insight__top_vendor_in_top_category',
    'x4c_insights_combined.insights__top_categories_in_mdg_segment',
    'x4c_insights_combined.insights__trending_products_growth',
  ],
  fill_fields: [],
  filter_config: {},
  filter_expression: '',
  filters: {},
  limit: '',
  model: 'sa_external',
  pivots: [],
  query_timezone: '',
  row_total: '',
  sorts: [],
  subtotals: [],
  total: false,
  view: 'x4c_insights_combined',
  vis_config: {},
  visible_ui_sections: '',
};
